import * as global from '../global';
export class Task {
	taskId: string;
	taskName: string;
	status: number;
	taskShortName: string;
	visibleToUsers: string[];
	constructor() {
		this.taskId = 't_' + global.generateRandomString(-1);
		this.taskName = 'Development & Testing';
		this.taskShortName = 'Dev&Test';
		this.status = 0;//0 - active, 1- deleted
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/.modal/task.ts